document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.fullwidth-slider');
  const header = document.querySelector('.header-wrapper');

  if (!slider || !header) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.remove('no-fv');
        } else {
          header.classList.add('no-fv');
        }
      });
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(slider);
});